import React, { useState, useEffect } from 'react'
import TimeRemaining from './Center/TimeRemaining'
import UserDetail from './Center/UserDetail'
import flaggedIcon from '../../../assets/images/flag-orange.png'
import exclamation from '../../../assets/images/exclamation-orange.png'
import Conversation from './Center/Conversation'
import ReportModal from './Right/Modals/ReportModal'
import { useDispatch, useSelector } from 'react-redux';
import { useGetUsersInChatQuery, useOpenChatMutation } from '../../../services/chatApi'

const Center = ({ socket, settingLastMsg }) => {
    // const { data, isLoading, isSuccess,refetch } = useGetUsersInChatQuery(undefined, {
    //   refetchOnFocus: true,
    //   refetchOnReconnect: true,
    // //   pollingInterval: 5000 // every 5 seconds
    // })
    // useEffect(() => {
    //   refetch();
    // }, []);
    const [chatData, setChatData] = useState(null);
     const [refreshKey,setRefreshKey]=useState(0)
    const currentChatUser = useSelector((state) => state.coachReducer)
  const [modalDisplay, setModalDisplay] = useState(false);
const [flaggedStatus, setFlaggedStatus] = useState("");

    const [openChat, { isLoading: chatOpenLoading, isSuccess: chatOpenSuccess }] = useOpenChatMutation()
    useEffect(() => {

        const fetchOpenChat = async () => {
            if (!currentChatUser?.coach_id) return;
            try {
                const formData = new FormData();
                formData.append('person_id', currentChatUser.coach_id);
                formData.append('page_no', '1');
                const response = await openChat(formData).unwrap();
                setChatData(response);
            } catch (error) {
            }
        };

        fetchOpenChat();
    }, [currentChatUser?.coach_id, openChat,refreshKey]);

     useEffect(() => {
    const handleBookingUpdate = () => {
      setRefreshKey(prev => prev + 1)
    }

    window.addEventListener('free-consultation-booked', handleBookingUpdate)
    
    return () => {
      window.removeEventListener('free-consultation-booked', handleBookingUpdate)
    }
  }, [])

    // Extract plan reservation data from openChat response
    const planReservation = chatData?.plan_reservation;
    const planDetails = planReservation?.plan_details;
    const freeSessions = planDetails?.free_consultation_no;
    const remaining = planReservation?.avail_consult;
    const dispatch = useDispatch()
  


    return (
        <div className="flex-[2] h-[92vh] p-2 ml-8 relative">
            <div className="w-full bg-white pt-6 rounded-[20px]  xl:h-[95%] 2xl:h-[97%] mt-10">
                <header className="w-[85%] mx-auto flex items-center h-10 justify-between">
                    <UserDetail />
                    <TimeRemaining />

                    {flaggedStatus &&
                        <div><img src={flaggedIcon} alt="flaggedIcon" className="mr-2 h-6" title='This client is flagged' /></div>
                    }

                    <img onClick={() => setModalDisplay(true)} src={exclamation} className="w-6 cursor-pointer h-6 object-contain" alt="report" />

                    {modalDisplay &&
                        <ReportModal
                            currentChatUser={currentChatUser}
                            onCloseModal={() => setModalDisplay(false)}
                        />
                    }

                </header>
                <hr className="border-heavy w-[85%] mx-auto my-3" />
                {planDetails && (
                    <div className="text-center text-[14.5px] font-medium text-black">
                        <span className="text-[#f97316] font-bold">
                            {remaining}
                        </span>
                        <span className="font-bold ">/</span>
                        <span className="font-bold">
                            {freeSessions}
                        </span>
                        <span className="ml-2 font-normal">session remaining</span>
                    </div>
                )}
                {/* <p>2/3  session remaining</p> */}
                <Conversation socket={socket} settingLastMsg={settingLastMsg} />
            </div>
        </div>
    )
}

export default Center